// Candidate status pipeline definitions
export const STATUSES = [
  { value: "submitted",  label: "Submitted",  color: "bg-gray-100 text-gray-700 border-gray-200" },
  { value: "screening",  label: "Screening",  color: "bg-blue-50 text-blue-700 border-blue-200" },
  { value: "interview",  label: "Interview",  color: "bg-purple-50 text-purple-700 border-purple-200" },
  { value: "offer",      label: "Offer",      color: "bg-amber-50 text-amber-700 border-amber-200" },
  { value: "hired",      label: "Hired",      color: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { value: "rejected",   label: "Rejected",   color: "bg-red-50 text-red-700 border-red-200" },
];

export const STATUS_MAP = STATUSES.reduce((m, s) => { m[s.value] = s; return m; }, {});

export function StatusBadge({ status, className = "" }) {
  const s = STATUS_MAP[status] || STATUS_MAP.submitted;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold border ${s.color} ${className}`}>
      {s.label}
    </span>
  );
}
